import React, { useState, useEffect } from 'react';

import { Button, Form } from 'react-bootstrap';
import UserChatGroup from '../components/UserChatGroup';

import iconGrid from '../assets/icon/grid.svg';
import iconList from '../assets/icon/list.svg';
import iconSearch from '../assets/icon/search.svg';
import inconGroupChat from '../assets/icon/groupChat.svg';

import { useUserStatus } from '../hooks/userStatus';
import { useToast } from '../hooks/toast';
import { useMessage } from '../hooks/message';
import api from '../services/apiClient';

import DataChatUser from '../interfaces/IDataChatUser';
import UserChatGroupList from '../components/UserChatGroupList';
import Users from '../interfaces/IUsers';

interface Group {
  seqGrupo: number;
  nomeGrupo: string;
}

interface Departament {
  seqDepartamento: number;
  nome: string;
}

const ChatGroup: React.FC = () => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [departaments, setDepartaments] = useState<Departament[]>([]);
  const [groupFilter, setGroupFilter] = useState(0);
  const [departamentFilter, setDepartamentFilter] = useState(0);
  const [nameFilter, setNameFilter] = useState('');
  const [userStatusFilter, setUserStatusFilter] = useState<Users[]>([]);
  const [showInGrid, setShowInGrid] = useState(false);

  const { userStatus } = useUserStatus();
  const { addToast } = useToast();
  const { addChatGroup } = useMessage();

  let debounceTimer: ReturnType<typeof setTimeout>;

  const handleFilterUser = (
    seqGrupo: number,
    seqDepartamento: number,
    nome: string
  ): void => {
    clearTimeout(debounceTimer);

    let filteredUser = userStatus;

    debounceTimer = setTimeout(() => {
      if (seqGrupo !== 0) {
        filteredUser = filteredUser.filter((user) =>
          user.grupo.some((g) => g.seqGrupo === seqGrupo)
        );
      }

      if (seqDepartamento !== 0) {
        filteredUser = filteredUser.filter((user) =>
          user.departamento.some((d) => d.seqDepartamento === seqDepartamento)
        );
      }

      if (nome !== '') {
        filteredUser = filteredUser.filter((user) =>
          user.nomeUsuario.toUpperCase().includes(nome.toUpperCase())
        );
      }

      filteredUser.sort((a, b) => a.status - b.status);

      setUserStatusFilter(filteredUser);
    }, 300);
  };

  const LoadGroup = (): void => {
    const seqUsuario = localStorage
      .getItem('@LiveChat:seqUsuario')
      ?.toUpperCase();
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get(`GrupoUsuario/grupos/${seqUsuario}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setGroups(
          response.data.data.sort((a: Group, b: Group) =>
            a.nomeGrupo.localeCompare(b.nomeGrupo)
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const LoadDepartament = (): void => {
    const seqUsuario = localStorage
      .getItem('@LiveChat:seqUsuario')
      ?.toUpperCase();
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('api/Departamento', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDepartaments(
          response.data.data.sort((a: Departament, b: Departament) =>
            a.nome.localeCompare(b.nome)
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addChat = (seqGrupo: number, seqUsuario: number): void => {
    const chat: DataChatUser = {
      seqGrupoConversa: 0,
      seqGrupo,
      nomeGrupo: '',
      user: '',
      seqUsuario,
      chatHistorico: 'N',
    };

    addChatGroup(chat);
  };

  useEffect(() => {
    LoadGroup();
    LoadDepartament();
  }, []);

  useEffect(() => {
    setUserStatusFilter(userStatus);
  }, [userStatus]);

  useEffect(() => {
    setUserStatusFilter(userStatus);
  }, []);

  return (
    <div className="h-100 d-flex flex-column">
      <h1 className="w-100 fw-bold text-start ms-2">Usuários</h1>
      <div className="d-flex align-items-center">
        <div
          className="d-flex ms-2"
          style={{
            height: '2.5rem',
            width: '2.5rem',
            backgroundColor: showInGrid ? '#B8B8B8' : '#fff',
            borderTopLeftRadius: '11px',
            borderBottomLeftRadius: '11px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
          }}
        >
          <button
            type="button"
            className="d-flex align-items-center justify-content-center border-0 bg-transparent"
            style={{
              height: '2.5rem',
              width: '2.5rem',
            }}
            onClick={() => setShowInGrid(true)}
          >
            <img
              src={iconGrid}
              alt="grid"
              style={{ height: '1.62rem', width: '1.62rem' }}
            />
          </button>
        </div>
        <div
          style={{
            height: '2.5rem',
            width: '2.5rem',
            backgroundColor: !showInGrid ? '#B8B8B8' : '#fff',
            borderTopRightRadius: '11px',
            borderBottomRightRadius: '11px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
          }}
        >
          <button
            type="button"
            className="d-flex align-items-center justify-content-center border-0 bg-transparent"
            style={{ height: '2.5rem', width: '2.5rem' }}
            onClick={() => setShowInGrid(false)}
          >
            <img
              src={iconList}
              className="color-white"
              alt="list"
              style={{ height: '1.62rem', width: '1.62rem' }}
            />
          </button>
        </div>

        <Form.Select
          aria-label="Default select example"
          className="inputBox ms-3"
          style={{ width: '33rem' }}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            setGroupFilter(Number(e.target.value));
            handleFilterUser(
              Number(e.target.value),
              departamentFilter,
              nameFilter
            );
          }}
        >
          <option value="0">Todos os Grupos ({userStatus.length})</option>
          {groups.map((group) => (
            <option value={group.seqGrupo} key={group.seqGrupo}>
              {group.nomeGrupo}
            </option>
          ))}
        </Form.Select>

        <Form.Select
          aria-label="Default select example"
          className="inputBox ms-3"
          style={{ width: '36rem' }}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            setDepartamentFilter(Number(e.target.value));
            handleFilterUser(groupFilter, Number(e.target.value), nameFilter);
          }}
        >
          <option value="0">
            Todos os Departamentos ({departaments.length})
          </option>
          {departaments.map((departament) => (
            <option
              value={departament.seqDepartamento}
              key={departament.seqDepartamento}
            >
              {departament.nome}
            </option>
          ))}
        </Form.Select>

        <Form.Control
          type="text"
          placeholder="Nome do usuário"
          name="nome"
          className="inputBox ms-3"
          onChange={(e) => {
            setNameFilter(e.target.value);
            handleFilterUser(groupFilter, departamentFilter, e.target.value);
          }}
        />

        <Button
          className="ms-3"
          onClick={() =>
            handleFilterUser(groupFilter, departamentFilter, nameFilter)
          }
        >
          <img
            src={iconSearch}
            alt="search"
            style={{ height: '1.75rem', width: '1.75rem' }}
          />
        </Button>
      </div>
      <div className="d-flex h-100 ms-2 mb-1">
        <div
          className="card position-static mt-3"
          style={{
            width: '30rem',
            borderRadius: '0.68rem',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          }}
        >
          <div
            className="table-responsive overflow-hidden"
            style={{
              borderTopLeftRadius: '0.68rem',
              borderTopRightRadius: '0.68rem',
              borderColor: 'transparent',
              backgroundColor: '#1A1A1A',
              fontSize: '1.25rem',
            }}
          >
            <span
              style={{
                color: '#fff',
                fontSize: '1.58rem',
                marginLeft: '0.6rem',
              }}
            >
              Grupo de Usuários
            </span>
          </div>
          <table className="table table-nowrap mb-0 table-striped-custom table-hover">
            <tbody className="overflow-auto">
              {groups.map((group: Group) => (
                <tr
                  key={group.seqGrupo}
                  onDoubleClick={() => addChat(group.seqGrupo, 0)}
                  className="cursor-pointer hover"
                  style={{ cursor: 'pointer' }}
                >
                  <td
                    className="d-flex align-items-center justify-content-between"
                    style={{ fontSize: '1.25rem' }}
                  >
                    {group.nomeGrupo}
                    <Button
                      className="p-0 m-0"
                      style={{ height: '2.1rem', width: '2.1rem' }}
                      onClick={() => {
                        addChat(group.seqGrupo, 0);
                      }}
                    >
                      <img
                        src={inconGroupChat}
                        style={{ height: '2rem', width: '2rem' }}
                        alt="chat"
                      />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {showInGrid ? (
          <div
            className="ms-3 mt-3 overflow-auto pb-1"
            style={{
              width: '93rem',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gridAutoRows: 'max-content',
              gap: '1rem',
            }}
          >
            <UserChatGroup users={userStatusFilter} addChat={addChat} />
          </div>
        ) : (
          <div
            className="d-flex ms-3 mt-3 overflow-auto"
            style={{
              width: '93rem',
              display: 'flex',
            }}
          >
            <UserChatGroupList users={userStatusFilter} addChat={addChat} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatGroup;
